import { render, staticRenderFns } from "./FindTutorExam.vue?vue&type=template&id=48f5b4e6&"
import script from "./FindTutorExam.vue?vue&type=script&lang=js&"
export * from "./FindTutorExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports